module.exports = __webpack_public_path__ + "static/media/logo.b50d96b1.png";